import React from "react";
import { Loader2, Mail } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const BriefPreferenceCard = ({ enabled, saving, onToggle }) => (
  <section
    data-testid="brief-preferences-card"
    className="bg-white border border-gray-200 rounded-2xl p-6 flex items-start gap-5"
  >
    <div
      className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
      style={{ background: "#FBE2EE" }}
    >
      <Mail size={18} strokeWidth={1.5} style={{ color: "#EC4899" }} />
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-3 flex-wrap">
        <h2 className="font-display text-lg tracking-tight font-medium leading-none">
          Daily Brief delivery
        </h2>
        <span
          data-testid="brief-status-pill"
          className={`font-mono text-[10px] uppercase tracking-widest px-2 py-1 rounded-full ${
            enabled ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-500"
          }`}
        >
          {enabled ? "On · 06:00 UTC" : "Paused"}
        </span>
      </div>
      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        {enabled
          ? "You'll get a fresh 3-story brief with talking points in your inbox each morning. Pausing stops delivery immediately — your subscription and generation quota are unaffected."
          : "Delivery is paused. Turn it back on any time to resume 06:00 UTC briefs. Your saved profile and quota stay intact."}
      </p>
    </div>
    <div className="flex flex-col items-end gap-1 shrink-0">
      <Switch
        data-testid="brief-toggle"
        checked={enabled}
        onCheckedChange={onToggle}
        disabled={saving}
        aria-label="Toggle Daily Brief delivery"
      />
      {saving && (
        <span className="font-mono text-[9px] uppercase tracking-widest text-gray-400 flex items-center gap-1">
          <Loader2 size={10} className="animate-spin" /> Saving
        </span>
      )}
    </div>
  </section>
);
